import CookiesService from 'services/CookiesService/CookiesService';

const accessTokenStorage = new CookiesService('access_token', { string: true });

export default accessTokenStorage;
